module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vback2-164af82a91620e7732560510e9e9e035.jpg";